import _WidgetBaseSP from 'more/_WidgetBaseSP';

import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MonthColumnPlanGroupEditor.html?raw';
import "../../../moreCore/UI/Edit/Edit";

import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import "../../../moreCore/UI/StaticTable/StaticTable";

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import ColorPicker from '../../../moreCore/UI/ColorPicker/ColorPicker';

import MonthColumnPlanGroupView from './MonthColumnPlanGroupView';

class MonthColumnPlanGroupEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    tableContainer: HTMLDivElement;
    createNewButtonContainer: HTMLDivElement;

    mainTable: MdsLax<InstanceType<typeof StaticTable>>;

    disableNewButton = false;

    myDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    fallBackPrimaryColor = "#000";
    fallBackSecondaryColor = "#fff";

    flagDataWasChanged = false;

    groupData: Array<MCP_group> = [];
    colorPickers: Array<MdsLax<InstanceType<typeof ColorPicker>>> = [];

    createNewButtonElem: HTMLButtonElement;

    private deletedElementsCounter = 0;

    //#region new group
    async _onCLick_AddNewGroup(ev: Event) {
        this.deletedElementsCounter--;
        this.showLoading();
        let newGroup: MCP_group = {
            ID: "",
            date_start: "",
            date_end: "",
            label: this.translations["MonthColumnPlan__groupNameInput_placeholder_unsaved"],
            tooltip: this.translations["MonthColumnPlan__groupNameInput_placeholder_unsaved"],
            draggable: true,
            primaryColor: "FFFFFF",
            secondaryColor: "000000",
        };
        let res = await this.writeRowData(newGroup);
        if ((typeof res == 'undefined') || (res == null) || (res["status"] != "success")) {
            this.showToast(this.translations["MonthColumnPlan__GroupEditor_onError_CreateNew"], "far fa-dizzy");
            this.hideLoading();
            return;
        }
        this.flagDataWasChanged = true;
        this.emit("GroupDataChanged", true);
        this.refreshAllGroupsAndReDrawTable();
        this.hideLoading();
        //wir machne eine entity view auf mit der neu erstellten gruppe
        this.__onClick_OpenGroupEntity(res["ID"]);
    }

    //#region remove group
    flagRemoveThisGroup = "";
    _onClick_RemoveGroup(ev: Event) {
        this.deletedElementsCounter++;
        let groupID = (ev.target as HTMLButtonElement).getAttribute("groupid");
        let groupName = "";
        for (let elem of this.groupData) {
            if (elem.ID == groupID) {
                groupName = elem.label;
            }
        }
        this.flagRemoveThisGroup = groupID;
        let dlg = new GenericDialog();
        dlg.destroyOnClose = true;
        let contentText = this.translations["MonthColumnPlan__deleteConfirmMessage_1"] + "<div class=\"w3-border w3-border-gray w3-light-gray w3-panel w3-padding\">" + groupName + "</div>" + this.translations["MonthColumnPlan__deleteConfirmMessage_2"];
        dlg.show(contentText, this.translations["MonthColumnPlan__deleteGroupHeaderMsg"], "", "fas fa-exclamation-triangle", 'okcancel', lang.hitch(this, (res) => {
            //1=ok
            if (res > 0) {
                this.showLoading();
                this.removeGroup();
                this.flagDataWasChanged = true;
                this.emit("GroupDataChanged", true);
            }
        }));
    }

    private removeGroup() {
        let removeThis = this.flagRemoveThisGroup;
        if (removeThis == "") {
            return;
        }
        this.deleteGroup(removeThis);
    }

    deleteGroup(grouID: string): void {
        let IDlist: Array<string> = [];
        IDlist.push(grouID);

        let json_value = JSON.stringify({ targetClassname: "appointment_draft_group", IDlist: IDlist });

        let url: string = window.appRoot + "MonthColumnPlan/DeleteGroup";

        this.RequestManager.post(
            url,
            {
                jsonData: json_value
            },
            lang.hitch(this, "_onDeleteGroup_response", grouID),
            lang.hitch(this, function (err) {
                if (err["Message"] && err["Message"] == "success") {
                    this._onDeleteGroup_response(grouID, err["Message"]);
                    this.hideLoading();
                    return;
                }
                console.error("ERROR: ", err);
            }),
            false // sync
        );

    }

    _onDeleteGroup_response() {
        this.showLoading();
        this.refreshAllGroupsAndReDrawTable();
    }

    async writeRowData(appointment: MCP_group) {
        let postData = { jsonData: JSON.stringify(appointment) }
        let apiURL = window.appRoot + "MonthColumnPlan/WriteGroupData";
        return new Promise((resolve, reject) => {
            this.RequestManager.post(apiURL, postData,
                (response) => {
                    resolve(response);
                },
                () => {
                    reject(null);
                }
            ),
                null
        });
    }

    public getWasChangedFlag() { //implement
        return this.flagDataWasChanged;
    }

    //#region fetchData
    refreshAllGroupsAndReDrawTable(): void { // holt gruppen daten & laded sie in den table
        let url: string = window.appRoot + "MonthColumnPlan/GetAllGroups";
        this.RequestManager.post(
            url,
            {
                jsonData: null
            },
            lang.hitch(this, this._onGetAllGroupsResponse),
            lang.hitch(this, function (err) {
                console.error("ERROR: ", err);
                this.hideLoading();
            }),
            false // sync
        );
    }

    private oldMinHeight = "";
    //#region draw table
    _onGetAllGroupsResponse(resp: any) {
        //setzt style damit dlg nicht so sehr rum springt
        this.oldMinHeight = this.domNode.style.minHeight;
        if (this.deletedElementsCounter < 3) { //wenn viele gruppen geloescht werden, setzten wir die minimale hoehe zuruck
            this.domNode.style.minHeight = this.domNode.offsetHeight + "px";
        }
        let groupDataList: Array<MCP_group> = resp as any;
        if (groupDataList.length > 0) {
            this.groupData = JSON.parse(JSON.stringify(groupDataList)); //deepcopy attempt
        } else {
            this.groupData = [];
        }
        for (let dat of this.groupData) {
            if ((dat["gDisp_1"] != null) && (typeof dat["gDisp_1"] != 'undefined')) { //wenn gDisp nicht null/undefined oder leerer string ist setzen wir den als display name
                if (dat["gDisp_1"] != "") {
                    dat["label"] = dat["gDisp_1"];
                }
            }
        }
        if ((this.mainTable != null) || (typeof this.mainTable != 'undefined')) {
            try {
                this.mainTable.destroyDescendants();
            } catch { console.warn("unable to destroy mainTable!"); }
            this.tableContainer.innerHTML = "";
        }
        this.mainTable = new StaticTable();
        this.mainTable.setLayout(this.getTableLayout());
        this.mainTable.setFormatter(lang.hitch(this, this._tableFormatter));
        this.mainTable.setCyAttribute("MonthColumnPlanGroupEditorTable");
        this.mainTable.placeAt(this.tableContainer);
        let dataList: Array<object> = [];
        for (let entry of groupDataList) {
            let secondaryColor = entry.secondaryColor;
            let primaryColor = entry.primaryColor;
            if (entry.secondaryColor == "null" || entry.secondaryColor == null) {
                secondaryColor = this.fallBackSecondaryColor;
            }
            if (entry.primaryColor == "null" || entry.primaryColor == null) {
                primaryColor = this.fallBackPrimaryColor;
            }
            let item = {
                groupNames: entry.ID,
                groupColor: entry.ID,
                actionButtons: entry.ID,
                ID: entry.ID,
            };
            dataList.push(item);
        }
        //destroy color pickers
        if (this.colorPickers.length > 0) {
            for (let picker of this.colorPickers) {
                try {
                    picker.destroyRecursive();
                } catch {
                    console.warn("unable to destroy color picker");
                }
            }
            this.colorPickers = [];
        }
        this.mainTable.setData(dataList);
        this.mainTable.setCellClick(lang.hitch(this, this._onClick_CellClick_OpenEntityViewer), 'groupNames');
        this.mainTable.setCellClick(lang.hitch(this, this._onClick_CellClick_OpenEntityViewer), 'groupColor');
        this.mainTable.setCellClick(lang.hitch(this, this._onClick_CellClick_DeleteEntry), 'actionButtons');
        //weil im StaticTable in updateEntity() ein timeout mit 150 ms is, warten wir kurz.
        if (this.groupData.length > 0) { //wenn keine gruppen vorhanden sind, braucht es eh kein loading screen
            this.showLoading();
        }
        setTimeout(lang.hitch(this, this._onContinue_tableDraw), 151);
    }

    //#region drawTable cont
    _onContinue_tableDraw() {
        this.hideLoading();
        //reset minimal height
        if (this.deletedElementsCounter < 3) {
            this.domNode.style.minHeight = this.oldMinHeight + "px";
        }
    }

    private _onClick_CellClick_OpenEntityViewer(cell: StaticTable.StaticTableCell<any>) {
        console.log("click", cell);
        this.__onClick_OpenGroupEntity(cell.entity.ID);
    }

    private _onClick_CellClick_DeleteEntry(cell: StaticTable.StaticTableCell<any>) {
        let targetDiv = cell.contentnode.querySelector(".groupDeleteButton,[groupid]");
        if (typeof targetDiv != 'undefined') {
            if (targetDiv != null) {
                this._onClick_RemoveGroup({ target: targetDiv } as any);
            }
        }
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<any>): boolean {
        let targetID: string = cell.value;
        let currentCell = cell.valuepath;
        let targetNode = cell.contentnode;
        let targetGroup: MCP_group = {} as any;
        if (currentCell != 'actionButtons') {
            for (let gr of this.groupData) {
                if (gr.ID == targetID) {
                    targetGroup = gr;
                }
            }
        }
        switch (currentCell) {
            case 'groupNames':
                cell.value = " ";
                let nameTxt = document.createElement('span');
                nameTxt.innerText = targetGroup.label;
                let coolDivElem = document.createElement('div');
                coolDivElem.setAttribute("groupid", targetID);
                coolDivElem.appendChild(nameTxt);
                targetNode.appendChild(coolDivElem);
                return true;
                break;
            case 'groupColor':
                //holt die farbe raus
                let newPicker = new ColorPicker;
                newPicker.setLabelVisibility(false);
                newPicker.setLabel("");
                newPicker.setUseTextColor(false);
                newPicker.setValue({
                    txtHex: this.fallBackSecondaryColor,
                    bgHex: "#" + targetGroup.primaryColor,
                });
                cell.value = "";
                newPicker.setNonInteractive(true);
                newPicker.placeAt(targetNode);
                newPicker.domNode.setAttribute("groupid", targetID);
                return true;
                break;
            case 'actionButtons': //action btn === delete button
                cell.value = "";
                let delDivCont = document.createElement('div');
                let delIco = document.createElement('i');
                delIco.setAttribute("class", "far fa-trash-alt warningTXT");
                delDivCont.setAttribute("class", "groupDeleteButton w3-center");
                delDivCont.setAttribute("style", "height:100%;");
                delDivCont.appendChild(delIco);
                delDivCont.setAttribute("groupid", targetID);
                //click wird jetzt ueber table gehandled, so wie es sein sollte... .-.
                //delDivCont.addEventListener("click", lang.hitch(this, this._onClick_RemoveGroup, { target: delDivCont }));
                targetNode.appendChild(delDivCont);
                return true;
                break;
        }

        return false;
    }

    private currentGroupView: MdsLax<InstanceType<typeof MonthColumnPlanGroupView>>;
    private __onClick_OpenGroupEntity(enttiyID: string) {
        this.flagDataWasChanged = true;
        if ((typeof this.currentGroupView != 'undefined') && (this.currentGroupView != null)) {
            try {
                this.currentGroupView.destroyRecursive();
            } catch {
                console.error("unable to destroy entity view for group");
            }
        }
        this.currentGroupView = new MonthColumnPlanGroupView();
        this.currentGroupView.showAsDlg(enttiyID);
        this.currentGroupView.getCurrentDlg().on("closed", lang.hitch(this, this.refreshAllGroupsAndReDrawTable));
    }

    //#region loading indicator
    flagIsLoading = false;
    private showLoading() {
        if (this.flagIsLoading == false) {
            this.StandbyStart(this.domNode);
            this.createNewButtonElem.disabled = true;
            this.flagIsLoading = true;
        }
    }

    private hideLoading() {
        if (this.flagIsLoading == true) {
            this.StandbyStop();
            this.createNewButtonElem.disabled = false;
            this.flagIsLoading = false;
        }
    }


    //#region postCreate
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.refreshAllGroupsAndReDrawTable();
        if (this.groupData.length > 0) {
            this.showLoading();
        }
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    //#region table definition
    private getTableLayout() {
        return {
            "rows": [
                {
                    "attributes": [
                        "groupNames",
                        "groupColor",
                        "actionButtons"
                    ],
                    "headings": [
                        this.translations["MonthColumnPlan__GroupEditor_Table_GroupName"],
                        this.translations["MonthColumnPlan__GroupEditor_Table_Color"],
                        " ",//leerzeichen, da ansonsten evtl platzhalter text angezeigt wird
                    ],
                    "colspans": [
                        4,
                        1,
                        1
                    ],
                    "widths": [
                        null,
                        "22ch",
                        "6ch"
                    ],
                    "colNamesInternal": [
                        "groupNames",
                        "groupColor",
                        "actionButtons"
                    ],
                    "bgColors": [
                        "",
                        "",
                        ""
                    ],
                    "txtColors": [
                        "",
                        "",
                        ""
                    ]
                }
            ],
            "name": "default",
            "label": "Standard"
        };
    }

}

export default mdsWidget(MonthColumnPlanGroupEditor);
